import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ costProfile, resource }) =>
    present(
      repository
        .saveCostProfileAssignation(costProfile, resource)
        .then(() => ({ costProfile, resource }))
        .catch(() => Promise.reject({ costProfile, resource })),
    );
}

export type { Interactor };

export { createInteractor };
